import { ActionCreator } from "redux";
import { ActionType, PlannerListMovingReservationSetAction } from "./type";

export const setMovingReservation: ActionCreator<
	PlannerListMovingReservationSetAction
> = (id: string) => ({
	type: ActionType.PlannerListMovingReservationSet,
	payload: {
		id
	}
});
